import React from "react";
function Privacy() {
  return (
    <div className="static-page">
      <h1 className="static-h1">Privacy Policy</h1>
      <p>Effective date: September 1, 2020</p>
      <h5>1. Introduction</h5>
      <p>Welcome to SlickPals LLC.</p>
      <p>
        SlickPals LLC (“us”, “we”, or “our”) operates www.slickpals.com
        (hereinafter referred to as “Service”).
      </p>
      <p>
        Our Privacy Policy governs your visit to www.slickpals.com, and explains
        how we collect, safeguard and disclose information that results from
        your use of our Service.
      </p>
      <p>
        We use your data to provide and improve Service. By using Service, you
        agree to the collection and use of information in accordance with this
        policy. Unless otherwise defined in this Privacy Policy, the terms used
        in this Privacy Policy have the same meanings as in our Terms and
        Conditions.
      </p>
      <p>
        Our Terms and Conditions (“Terms”) govern all use of our Service and
        together with the Privacy Policy constitutes your agreement with us
        (“agreement”).
      </p>
      <h5>2. Definitions</h5>
      <p>
        SERVICE means the www.slickpals.com website operated by SlickPals LLC.
      </p>
      <p>
        PERSONAL DATA means data about a living individual who can be identified
        from those data (or from those and other information either in our
        possession or likely to come into our possession).
      </p>
      <p>
        USAGE DATA is data collected automatically either generated by the use
        of Service or from Service infrastructure itself (for example, the
        duration of a page visit).
      </p>
      <p>
        COOKIES are small files stored on your device (computer or mobile
        device).
      </p>
      <p>
        DATA SUBJECT is any living individual who is the subject of Personal
        Data.
      </p>
      <p>
        THE USER is the individual using our Service. The User corresponds to
        the Data Subject, who is the subject of Personal Data.
      </p>
      <h5>3. Information Collection and Use</h5>
      <p>
        We collect several different types of information for various purposes
        to provide and improve our Service to you.
      </p>
      <h5>4. Types of Data Collected</h5>
      <p>
        <strong>Personal Data</strong>
      </p>
      <p>
        While using our Service, we may ask you to provide us with certain
        personally identifiable information that can be used to contact or
        identify you (“Personal Data”). Personally identifiable information may
        include, but is not limited to:
      </p>
      <ul>
        <li>0.1. Email address</li>
        <li>0.2. First name and last name</li>
        <li>0.3. Phone number</li>
        <li>0.4. Address, Country, State, Province, ZIP/Postal code, City</li>
        <li>0.5. Cookies and Usage Data</li>
      </ul>
      <p>
        We may use your Personal Data to contact you with newsletters, marketing
        or promotional materials and other information that may be of interest
        to you. You may opt out of receiving any, or all, of these
        communications from us by following the unsubscribe link.
      </p>
      <p>
        <strong>Usage Data</strong>
      </p>
      <p>
        We may also collect information that your browser sends whenever you
        visit our Service or when you access Service by or through any device
        (“Usage Data”).
      </p>
      <p>
        This Usage Data may include information such as your computer’s Internet
        Protocol address (e.g. IP address), browser type, browser version, the
        pages of our Service that you visit, the time and date of your visit,
        the time spent on those pages, unique device identifiers and other
        diagnostic data.
      </p>
      <p>
        When you access Service with a device, this Usage Data may include
        information such as the type of device you use, your device unique ID,
        the IP address of your device, your device operating system, the type of
        Internet browser you use, unique device identifiers and other diagnostic
        data.
      </p>
      <p>
        <strong>Location Data</strong>
      </p>
      <p>
        We may use and store information about your location if you give us
        permission to do so (“Location Data”). We use this data to provide
        features of our Service, to improve and customize our Service.
      </p>
      <p>
        You can enable or disable location services when you use our Service at
        any time by way of your device settings.
      </p>
      <p>
        <strong>Tracking Cookies Data</strong>
      </p>
      <p>
        We use cookies and similar tracking technologies to track the activity
        on our Service and we hold certain information.
      </p>
      <p>
        Cookies are files with a small amount of data which may include an
        anonymous unique identifier. Cookies are sent to your browser from a
        website and stored on your device. Other tracking technologies are also
        used such as beacons, tags and scripts to collect and track information
        and to improve and analyze our Service.
      </p>
      <p>
        You can instruct your browser to refuse all cookies or to indicate when
        a cookie is being sent. However, if you do not accept cookies, you may
        not be able to use some portions of our Service.
      </p>
      <p>
        <strong>Examples of Cookies we use:</strong>
      </p>
      <ul>
        <li>
          0.1. Session Cookies: We use Session Cookies to operate our Service.
        </li>
        <li>
          0.2. Preference Cookies: We use Preference Cookies to remember your
          preferences and various settings.
        </li>
        <li>
          0.3. Security Cookies: We use Security Cookies for security purposes.
        </li>
        <li>
          0.4. Advertising Cookies: Advertising Cookies are used to serve you
          with advertisements that may be relevant to you and your interests.
        </li>
      </ul>
      <p>
        <strong>Other Data</strong>
      </p>
      <p>
        While using our Service, we may also collect the following information:
        sex, age, citizenship, address, telephone number and other data.
      </p>
      <h5>5. Use of Data</h5>
      <p>SlickPals LLC uses the collected data for various purposes:</p>
      <ul>
        <li>0.1. to provide and maintain our Service;</li>
        <li>0.2. to notify you about changes to our Service;</li>
        <li>
          0.3. to allow you to participate in interactive features of our
          Service when you choose to do so;
        </li>
        <li>0.4. to provide customer support;</li>
        <li>
          0.5. to gather analysis or valuable information so that we can improve
          our Service;
        </li>
        <li>0.6. to monitor the usage of our Service;</li>
        <li>0.7. to detect, prevent and address technical issues;</li>
        <li>0.8. to fulfil any other purpose for which you provide it;</li>
        <li>
          0.9. to carry out our obligations and enforce our rights arising from
          any contracts entered into between you and us, including for billing
          and collection;
        </li>
        <li>
          0.10. to provide you with notices about your account and/or
          subscription, including expiration and renewal notices,
          email-instructions, etc.;
        </li>
        <li>
          0.11. to provide you with news, special offers and general information
          about other goods, services and events which we offer that are similar
          to those that you have already purchased or enquired about unless you
          have opted not to receive such information;
        </li>
        <li>
          0.12. in any other way we may describe when you provide the
          information;
        </li>
        <li>0.13. for any other purpose with your consent.</li>
      </ul>
      <h5>6. Retention of Data</h5>
      <p>
        We will retain your Personal Data only for as long as is necessary for
        the purposes set out in this Privacy Policy. We will retain and use your
        Personal Data to the extent necessary to comply with our legal
        obligations (for example, if we are required to retain your data to
        comply with applicable laws), resolve disputes, and enforce our legal
        agreements and policies.
      </p>
      <p>
        We will also retain Usage Data for internal analysis purposes. Usage
        Data is generally retained for a shorter period, except when this data
        is used to strengthen the security or to improve the functionality of
        our Service, or we are legally obligated to retain this data for longer
        time periods.
      </p>
      <h5>7. Transfer of Data</h5>
      <p>
        Your information, including Personal Data, may be transferred to – and
        maintained on – computers located outside of your state, province,
        country or other governmental jurisdiction where the data protection
        laws may differ from those of your jurisdiction.
      </p>
      <p>
        If you are located outside India and choose to provide information to
        us, please note that we transfer the data, including Personal Data, to
        India and process it there.
      </p>
      <p>
        Your consent to this Privacy Policy followed by your submission of such
        information represents your agreement to that transfer.
      </p>
      <p>
        SlickPals LLC will take all the steps reasonably necessary to ensure
        that your data is treated securely and in accordance with this Privacy
        Policy and no transfer of your Personal Data will take place to an
        organisation or a country unless there are adequate controls in place
        including the security of your data and other personal information.
      </p>
      <h5>8. Disclosure of Data</h5>
      <p>
        We may disclose personal information that we collect, or you provide:
      </p>
      <p>
        <strong>0.1. Disclosure for Law Enforcement.</strong>
      </p>
      <p>
        Under certain circumstances, we may be required to disclose your
        Personal Data if required to do so by law or in response to valid
        requests by public authorities.
      </p>
      <p>
        <strong>0.2. Business Transaction.</strong>
      </p>
      <p>
        If we or our subsidiaries are involved in a merger, acquisition or asset
        sale, your Personal Data may be transferred.
      </p>
      <ul>
        <li>0.3. Other cases. We may disclose your information also:</li>
        <li>0.3.1. to our subsidiaries and affiliates;</li>
        <li>
          0.3.2. to contractors, service providers, and other third parties we
          use to support our business;
        </li>
        <li>0.3.3. to fulfill the purpose for which you provide it;</li>
        <li>
          0.3.4. for the purpose of including your company’s logo on our
          website;
        </li>
        <li>
          0.3.5. for any other purpose disclosed by us when you provide the
          information;
        </li>
        <li>0.3.6. with your consent in any other cases;</li>
        <li>
          0.3.7. if we believe disclosure is necessary or appropriate to protect
          the rights, property, or safety of the Company, our customers, or
          others.
        </li>
      </ul>
      <h5>9. Security of Data</h5>
      <p>
        The security of your data is important to us but remember that no method
        of transmission over the Internet or method of electronic storage is
        100% secure. While we strive to use commercially acceptable means to
        protect your Personal Data, we cannot guarantee its absolute security.
      </p>
      <h5>
        10. Your Data Protection Rights Under General Data Protection Regulation
        (GDPR)
      </h5>
      <p>
        We aim to take reasonable steps to allow you to correct, amend, delete,
        or limit the use of your Personal Data.
      </p>
      <p>
        If you wish to be informed what Personal Data we hold about you and if
        you want it to be removed from our systems, please email us at
        help@slickpals.com.
      </p>
      <p>
        In certain circumstances, you have the following data protection rights:
      </p>
      <ul>
        <li>
          0.1. the right to access, update or to delete the information we have
          on you;
        </li>
        <li>
          0.2. the right of rectification. You have the right to have your
          information rectified if that information is inaccurate or incomplete;
        </li>
        <li>
          0.3. the right to object. You have the right to object to our
          processing of your Personal Data;
        </li>
        <li>
          0.4. the right of restriction. You have the right to request that we
          restrict the processing of your personal information;
        </li>
        <li>
          0.5. the right to data portability. You have the right to be provided
          with a copy of your Personal Data in a structured, machine-readable
          and commonly used format;
        </li>
        <li>
          0.6. the right to withdraw consent. You also have the right to
          withdraw your consent at any time where we rely on your consent to
          process your personal information;
        </li>
      </ul>
      <p>
        Please note that we may ask you to verify your identity before
        responding to such requests. Please note, we may not able to provide
        Service without some necessary data.
      </p>
      <h5>11. Your Data Protection Rights </h5>
      <ul>
        <li>0.1. users can visit our site anonymously;</li>

        <li>
          0.2. our Privacy Policy link includes the word “Privacy”, and can
          easily be found on the home page of our website;
        </li>
        <li>
          0.3. users will be notified of any privacy policy changes on our
          Privacy Policy Page;
        </li>
        <li>
          0.4. users are able to change their personal information by emailing
          us at help@slickpals.com.
        </li>
      </ul>
      <p>Our Policy on “Do Not Track” Signals:</p>
      <p>
        We honor Do Not Track signals and do not track, plant cookies, or use
        advertising when a Do Not Track browser mechanism is in place. Do Not
        Track is a preference you can set in your web browser to inform websites
        that you do not want to be tracked.
      </p>
      <p>
        You can enable or disable Do Not Track by visiting the Preferences or
        Settings page of your web browser.
      </p>
      <h5>12. Service Providers</h5>
      <p>
        We may employ third party companies and individuals to facilitate our
        Service (“Service Providers”), provide Service on our behalf, perform
        Service-related services or assist us in analysing how our Service is
        used.
      </p>
      <p>
        These third parties have access to your Personal Data only to perform
        these tasks on our behalf and are obligated not to disclose or use it
        for any other purpose.
      </p>
      <h5>13. Analytics</h5>
      <p>
        We may use third-party Service Providers to monitor and analyze the use
        of our Service.
      </p>
      <h5>14. CI/CD tools</h5>
      <p>
        We may use third-party Service Providers to automate the development
        process of our Service.
      </p>
      <h5>15. Advertising</h5>
      <p>
        We may use third-party Service Providers to show advertisements to you
        to help support and maintain our Service.
      </p>
      <h5>16. Behavioral Remarketing</h5>
      <p>
        We may use remarketing services to advertise on third party websites to
        you after you visited our Service. We and our third-party vendors use
        cookies to inform, optimise and serve ads based on your past visits to
        our Service.
      </p>
      <h5>17. Payments</h5>
      <p>
        We may provide paid products and/or services within Service. In that
        case, we use third-party services for payment processing (e.g. payment
        processors).
      </p>
      <p>
        We will not store or collect your payment critical details. That
        information is provided directly to our third-party payment processors
        whose use of your personal information is governed by their Privacy
        Policy.
      </p>
      <h5>18. Links to Other Sites</h5>
      <p>
        Our Service may contain links to other sites that are not operated by
        us. If you click a third party link, you will be directed to that third
        party’s site. We strongly advise you to review the Privacy Policy of
        every site you visit.
      </p>
      <p>
        We have no control over and assume no responsibility for the content,
        privacy policies or practices of any third party sites or services.
      </p>
      <h5>19. Children’s Privacy</h5>
      <p>
        Our Services are not intended for use by children under the age of 18
        (“Child” or “Children”).
      </p>
      <p>
        We do not knowingly collect personally identifiable information from
        Children under 18. If you become aware that a Child has provided us with
        Personal Data, please contact us. If we become aware that we have
        collected Personal Data from Children without verification of parental
        consent, we take steps to remove that information from our servers.
      </p>
      <h5>20. Changes to This Privacy Policy</h5>
      <p>
        We may update our Privacy Policy from time to time. We will notify you
        of any changes by posting the new Privacy Policy on this page.
      </p>
      <p>
        We will let you know via email and/or a prominent notice on our Service,
        prior to the change becoming effective and update “effective date” at
        the top of this Privacy Policy.
      </p>
      <p>
        You are advised to review this Privacy Policy periodically for any
        changes. Changes to this Privacy Policy are effective when they are
        posted on this page.
      </p>
      <h5>21. Contact Us</h5>
      <p>
        If you have any questions about this Privacy Policy, please contact us
        by email: help@slickpals.com.
      </p>
    </div>
  );
}
export default Privacy;
